import Vue from "vue";
import Router from "vue-router";
import bookingWidget from "./components/bookingWidget.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "widget",
      component: bookingWidget,
      props: route => ({
        companyId: route.query.companyId,
        activeBranch: route.query.activeBranch,
        salonhubname: route.query.sh,
        lang: route.query.lang,
        gender: route.query.gender,
        clientIntel: route.query.ci,
        clientOrder: route.query.cio,
        treatmentByParam: route.query.shtm,
        clientName: route.query.shname,
        clientEmail: route.query.shem,
        clientTel: route.query.shtel,
        showPrice: route.query.shp,
        src: route.query.src
      }),
    },
  ]
});
